import './App.css'
import { Heading } from '@shopify/polaris'
import Images from './components/images/Images';

function App() {
  return (
    <div>
      <header>
        <img src="https://www.nasa.gov/sites/all/themes/custom/nasatwo/images/nasa-logo.svg" alt="logo NASA" />
        <Heading>Let's take a look at the amazing photos from NASA. <br></br> There are you can see all Astronomy Pictures of the Day from 2015 to 2022.</Heading>
      </header>
      <Images />
      <footer>Project by&nbsp; <a href='https://dolgireva.dev/'>Natalia Dolgireva</a>, 2022 </footer>
    </div>
  );
}

export default App;